import toaster from "../../common/toaster";

export default class ApprovalSystem {
    /**
     * @param options {{approvePrivilege, onElementUpdate, getElements, onStateUpdate, onAllUpdatesComplete}}
     */
    constructor(options = {}) {
        this.approvePrivilege = options.approvePrivilege ?? false;
        this.onElementUpdate = options.onElementUpdate ?? ((index) => Promise.resolve());
        this.getElements = options.getElements ?? (() => []);
        this.onStateUpdate = options.onStateUpdate ?? ((index) => {});
    }

    checkForApprovePrivilegeAndWarn(force = false) {
        if (!this.approvePrivilege || force) {
            toaster.error(Lang.langGet("You don't have the right to approve."));
            return false;
        }
        return true;
    }

    async approveAll() {
        if (!this.checkForApprovePrivilegeAndWarn()) return;

        const elements = this.getElements();
        const updatePromises = [];

        elements.forEach((element, index) => {
            updatePromises.push(this.approveElement(index));
        });

        await Promise.all(updatePromises);
    }

    async disapproveAll() {
        if (!this.checkForApprovePrivilegeAndWarn()) return;

        const elements = this.getElements();
        const updatePromises = [];

        elements.forEach((element, index) => {
            updatePromises.push(this.disapproveElement(index));
        });

        await Promise.all(updatePromises);
    }

    async approve(index) {
        if (!this.checkForApprovePrivilegeAndWarn()) return;

        await this.approveElement(index);
        this.onStateUpdate(index);
    }

    async disapprove(index, force = false) {
        if (!this.checkForApprovePrivilegeAndWarn(force)) return;

        await this.disapproveElement(index);
        this.onStateUpdate(index);
    }

    async approveElement(index) {
        const elements = this.getElements();
        const element = elements[index];
        if (element && !element.data.approved) {
            element.data.approved = true;
            await this.onElementUpdate(index);
        }
    }

    async disapproveElement(index) {
        const elements = this.getElements();
        const element = elements[index];
        if (element && element.data.approved) {
            element.data.approved = false;
            await this.onElementUpdate(index);
        }
    }
}
